// 供应链相关
import qs from 'qs'
import axios from '@/api/apiClient'

export const getSupplyInfoList = (unicode) => {
  console.log('getSupplyInfoList_api', unicode)
  return axios.$get(`/api/supply/info/${unicode}`)
}

export const getMySupplyInfoList = () => {
  return axios.$get('/api/supply/myInfo/list')
}

// 获取供应链标签（树结构）
export const getIndustrySupply = (supplyId) => {
  return axios.$get(`/api/base/industry/supply/${supplyId}`)
}

// 获取供应链企业
export const getSupplyCompany = (query) => {
  return axios.$get(`/api/supply/company${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取供应链产品
export const getSupplyProduct = (query) => {
  return axios.$get(`/api/supply/product${query ? `?${qs.stringify(query)}` : ''}`)
}

// 更新供应链行业分类
export const postSupplyUpdateIndustry = (param) => {
  return axios.$post('/api/supply/updateIndustry', param)
}

/**
 * 元宇宙会客厅列表
  参数	说明	是否必填
  supplyId	供应链id	是
  associationId	协会id	是
  industryId	二级行业id	否
  industryPId	一次行业id	否
  thirddFlag	1只查含有3D的企业 0查询所有	否
 */
export const getSupplyThirddList = (query) => {
  return axios.$get(`/api/company/info/supply/pageWithThirdd${query ? `?${qs.stringify(query)}` : ''}`)
}

// 申请入驻
export const setSupplyApply = (param) => {
  return axios.$post('/api/supply/apply', param)
}

/**
 * 云产品查询接口
 * @param {*} unicode 必传
 * @param {*} industry 二级行业标签 必传
 * @param {*} brandId 品牌id 必传
 * @returns
 */
export const getProduct = (query) => {
  return axios.$get(`/api/supply/product/${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 基础信息（入链企业，入链产品，公司logo，品牌logo，元宇宙）
 *
 返回示例
 参数 类型 说明
 company Object 入链企业
 brand Object 品牌
 thirdd Object 元宇宙正面
 thirddSide Object 元宇宙侧面
 product Object 入链产品
 companyLogo Object 产品侧边公司logo
 */
export const getSupplyIndexInfo = (supplyChainId, query) => {
  return axios.$get(`/api/supply/index/info/${supplyChainId}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 关联信息（投标、云上展览、云头条、云采购、云头条侧面、全球展览、全球会议、云直播）
 * 参数 类型 说明
 biding Object 投标
 upExhibition Object 云上展览
 complex Object 云头条
 purchase Object 云采购
 complexSide Object 云头条侧面
 downExhibition Object 全球展览
 meeting Object 全球会议
 live Object 云直播
 */
export const getSupplyIndexRelative = (supplyChainId, query) => {
  return axios.$get(`/api/supply/index/relative/${supplyChainId}${query ? `?${qs.stringify(query)}` : ''}`)
}

export const getListContextOrAssociationOrSupport = (query) => {
  return axios.$get(
    `/api/supplyChainSupport/getListContextOrAssociationOrSupport${query ? `?${qs.stringify(query)}` : ''}`,
  )
}

/**
 * 行业协会分页列表
 * current 当前页 是
 * supplyId 供应链id 否
 * @returns
 */
export const getSupplyChainAssociationList = (query) => {
  return axios.$get(`/api/supplyChainAssociation/selectPageByApp${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 行业协会详情页
 * @param {*} query
 * @returns
 */
export const getSupplyChainAssociationDetail = (query) => {
  return axios.$get(`/api/supplyChainAssociation/getDetail${query ? `?${qs.stringify(query)}` : ''}`)
}

// 供应链行业查询--供应链所属行业 (热门产品二级行业分类)
export const getSupplyIndustry = (supplyId) => {
  return axios.$get(`/api/supply/industry/${supplyId}`)
}

// 商机 - 供应链列表
export const getSupplyBusinessList = (location, query) => {
  return axios.$get(`/api/business/supplyChain/pc_home${query ? `?${qs.stringify(query)}` : ''}`)
}
